import React from 'react';

const SandClockVector = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <circle cx="32" cy="32" r="32" fill="#E6F1FE" />
    <path
      d="M42.95 18.1982H21"
      stroke="#1C3C5F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 45.2383H42.95"
      stroke="#1C3C5F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.6899 45.2383V41.7182C23.6899 37.9182 25.2299 36.2482 27.6599 34.2182C29.0699 33.0382 30.0799 32.2882 30.0799 31.7182C30.0799 31.1482 29.0799 30.3982 27.6599 29.2182C25.2299 27.1882 23.6899 25.5282 23.6899 21.7182V18.1982"
      stroke="#1C3C5F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.26 45.2383V41.7182C40.26 37.9182 38.72 36.2482 36.29 34.2182C34.88 33.0382 33.87 32.2882 33.87 31.7182C33.87 31.1482 34.87 30.3982 36.29 29.2182C38.72 27.1882 40.26 25.5282 40.26 21.7182V18.1982"
      stroke="#1C3C5F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SandClockVector;
